import Link from 'next/link'
import { ArticleJsonLd } from 'next-seo'

import * as S from './styles'
import { useRecommendedArticles } from './useRecommendedArticles'
import { Text } from '@/components'
import { BlogCard } from '@/components/blogCard'
import { RecommendedArticles } from '@/service/api/blog'
import { toStructuredData } from '@/service/api/blog/blogMapper'

export type RecommendedArticlesProps = {
  data: RecommendedArticles
}
export const RecommendedArticlesContainer: React.FC<
  RecommendedArticlesProps
> = ({ data }) => {
  const { isBiggerMobile, isMobile, isTablet, fontSizes } =
    useRecommendedArticles()
  const isWidthOnMobileRange = isBiggerMobile || isMobile || isTablet

  return (
    <S.RecommendedArticles>
      <Text size={fontSizes.title} color="black">
        {data.recommendedArticlesTitle}
      </Text>
      <S.ArticlesContainer>
        {!!data.recommendedArticles.length && isWidthOnMobileRange ? (
          <BlogCard
            slug={data.recommendedArticles[0].slug}
            src={data.recommendedArticles[0].src}
            alt={data.recommendedArticles[0].alt}
            title={data.recommendedArticles[0].title}
            author={data.recommendedArticles[0].author}
            tags={data.recommendedArticles[0].tags}
            publishedAt={data.recommendedArticles[0].publishedAt}
          />
        ) : (
          data.recommendedArticles.map((blogPost) => (
            <>
              <ArticleJsonLd {...toStructuredData(blogPost)} />
              <Link
                key={blogPost.slug}
                href={`/blog/${blogPost.slug}`}
                passHref
              >
                <BlogCard
                  slug={blogPost.slug}
                  src={blogPost.src}
                  alt={blogPost.alt}
                  title={blogPost.title}
                  author={data.recommendedArticles[0].author}
                  tags={blogPost.tags}
                  publishedAt={data.recommendedArticles[0].publishedAt}
                />
              </Link>
            </>
          ))
        )}
      </S.ArticlesContainer>
    </S.RecommendedArticles>
  )
}
